import React, { DetailedHTMLProps, memo, useRef } from 'react';
import cx from 'classnames';

import uuidV4 from 'uuid-v4';
import styles from './Checkbox.module.css';

export type Props = DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  id?: string;
  label?: string;
  inlineLabel?: boolean;
  basicStyle?: boolean;
  indeterminate?: boolean;
};

const Checkbox = ({
  id: idProp,
  label,
  inlineLabel,
  basicStyle,
  indeterminate,
  className = '',
  ...rest
}: Props) => {
  const ref = React.useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    if (typeof indeterminate === 'boolean' && ref.current) {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
  }, [ref, rest.checked, indeterminate]);

  const id = useRef(idProp || uuidV4()).current;

  if (label) {
    return (
      <div className={cx(styles.root, { [styles.inlineLabel]: inlineLabel })}>
        {!inlineLabel && (
          <label className={styles.label} htmlFor={id}>
            {label}
          </label>
        )}
        <input
          id={id}
          className={cx(className, styles.checkbox, {
            [styles.checkboxFancy]: !basicStyle,
          })}
          aria-label={label}
          type="checkbox"
          ref={ref}
          {...rest}
        />
        {inlineLabel && (
          <label
            className={cx(styles.label, styles.inlineLabelLabel)}
            htmlFor={id}
          >
            {label}
          </label>
        )}
      </div>
    );
  }

  return (
    <input
      className={cx(className, styles.checkbox, {
        [styles.checkboxFancy]: !basicStyle,
      })}
      type="checkbox"
      ref={ref}
      {...rest}
    />
  );
};

export default memo(Checkbox);
